import { render, staticRenderFns } from "./caseDetails.vue?vue&type=template&id=3ee56d1e&scoped=true&class=carbon"
import script from "./caseDetails.vue?vue&type=script&lang=js"
export * from "./caseDetails.vue?vue&type=script&lang=js"
import style0 from "./caseDetails.vue?vue&type=style&index=0&id=3ee56d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee56d1e",
  null
  
)

export default component.exports